export const TAGE = {
  monday: 0,
  tuesday: 1,
  wednesday: 2,
  thursday: 3,
  friday: 4,
  saturday: 5,
  sunday: 6,
} as const;

export type Tage = typeof TAGE;

export function getTageKeyByValue(
  value: Tage[keyof Tage],
): keyof Tage | undefined {
  return (Object.keys(TAGE) as Array<keyof Tage>).find(
    (key) => TAGE[key] === value,
  );
}

export const arbeitstage = {
  EIN_TAG: '1 Tag',
  ZWEI_TAGE: '2 Tage',
  DREI_TAGE: '3 Tage',
  VIER_TAGE: '4 Tage',
  FUENF_TAGE: '5 Tage',
  SECHS_TAGE: '6 Tage',
  SIEBEN_TAGE: '7 Tage',
  FLEXIBEL: 'flexibel',
} as const;

export type Arbeitstage = typeof arbeitstage;
